import { render, staticRenderFns } from "./EvaluationsOfMyTeamDetails.vue?vue&type=template&id=2d609360"
import script from "./EvaluationsOfMyTeamDetails.vue?vue&type=script&lang=js"
export * from "./EvaluationsOfMyTeamDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports